module.exports = __webpack_public_path__ + "static/img/new-home-ai.4114a6c8.png";